export enum NotificationType {
  TASK_COMPLETED = 'task-completed',
  TASK_DELETED = 'task-deleted',
  TASK_ASSIGNED= 'task-assigned',
  TASK_REASSIGNED = 'task-reassigned',
  CHAT_CREATED = 'chat-created', // non si riesce ad usare la cloud function chat-group-change-notification per questo evento
  ADDED_USER_TO_CHAT = 'added-user-to-chat',
  REMOVED_USER_FROM_CHAT = 'removed-user-from-chat',
  PROMOTED_TO_OWNER = 'promoted-to-owner',
  PROMOTED_TO_ADMIN = 'promoted-to-admin',
  DEMOTED_FROM_ADMIN = 'demoted-from-admin',
  GRANTED_WRITE_PERMISSIONS = 'granted-write-permissions',
  REVOKED_WRITE_PERMISSIONS = 'revoked-write-permissions',
  NEW_TEXT = 'new-text',
  NEW_JOURNAL = 'new-journal',
  NEW_PHOTO_GALLERY = 'new-photo-gallery',
  NEW_SURVEY = 'new-survey',
  NEW_CONSTRUCTION_DOCUMENT = 'new-construction-document',
  NEW_EQUIPMENT = 'new-equipment',
  SHARE_EQUIPMENT = 'share-equipment',
  SHARE_ACTOR_DOCUMENT = 'share-actor-document',
  NEW_ACTIVITY = 'new-activity',
  AI_VALIDATION_COMPLETED = 'ai-validation-completed',
  AI_VALIDATION_FAILED = 'ai-validation-failed'
}
